__webpack_require__.p = "https://dcs-static.gprod.postmedia.digital/21.1.1/websites/js/";